import React, { useState } from 'react';

const CategoryTree = ({ onSelectCategory }) => {
  const [expandedCategories, setExpandedCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  
  // بيانات الفئات كما في الصورة
  const categories = [
    {
      id: 1,
      name: 'الديكورات الخارجية',
      icon: '🚗',
      subcategories: [
        { id: 11, name: 'المرايا الخارجية', icon: '👁️' },
        { id: 12, name: 'المصابيح الأمامية والخلفية', icon: '💡' },
        { id: 13, name: 'الواجهات الأمامية والخلفية', icon: '🏗️' },
        { id: 14, name: 'الأجنحة والعتبات', icon: '✨' },
        { id: 15, name: 'الزجاج والنوافذ', icon: '🪟' },
        { id: 16, name: 'الملحقات الخارجية', icon: '🔧' },
      ]
    },
    {
      id: 2,
      name: 'الديكورات الداخلية',
      icon: '🚪',
      subcategories: [
        { id: 21, name: 'لوحة القيادة', icon: '🎛️' },
        { id: 22, name: 'المقاعد والأغطية', icon: '🪑' },
        { id: 23, name: 'السقف والستائر', icon: '🏠' },
        { id: 24, name: 'الأرضيات والسجاد', icon: '🛋️' },
        { id: 25, name: 'النوافذ الداخلية', icon: '🪟' },
        { id: 26, name: 'التكييف والتدفئة', icon: '❄️' },
      ]
    },
    {
      id: 3,
      name: 'المحرك والوقود',
      icon: '⚙️',
      subcategories: [
        { id: 31, name: 'أجزاء المحرك الأساسية', icon: '🔩' },
        { id: 32, name: 'نظام الوقود', icon: '⛽' },
        { id: 33, name: 'نظام العادم', icon: '💨' },
        { id: 34, name: 'التبريد والتشحيم', icon: '💧' },
        { id: 35, name: 'الكهرباء والإشعال', icon: '⚡' },
      ]
    },
    {
      id: 4,
      name: 'نظام التعليق والتوجيه',
      icon: '🔄',
      subcategories: [
        { id: 41, name: 'العجلات والإطارات', icon: '🛞' },
        { id: 42, name: 'المحاور والمفاصل', icon: '⚙️' },
        { id: 43, name: 'الينابيع وممتصات الصدمات', icon: '🌀' },
        { id: 44, name: 'نظام التوجيه', icon: '🧭' },
      ]
    },
    {
      id: 5,
      name: 'نظام الفرامل',
      icon: '🛑',
      subcategories: [
        { id: 51, name: 'فرامل القرص', icon: '⭕' },
        { id: 52, name: 'فرامل الطبل', icon: '🥁' },
        { id: 53, name: 'أنظمة الفرامل المساعدة', icon: '🆘' },
        { id: 54, name: 'أسطوانات الفرامل', icon: '🔧' },
        { id: 55, name: 'سائل الفرامل', icon: '💧' },
      ]
    },
    {
      id: 6,
      name: 'نظام نقل الحركة',
      icon: '⚡',
      subcategories: [
        { id: 61, name: 'القابض', icon: '🔄' },
        { id: 62, name: 'صندوق التروس', icon: '📦' },
        { id: 63, name: 'مهايئ الحركة', icon: '⚙️' },
        { id: 64, name: 'عمود الدوران', icon: '🔩' },
        { id: 65, name: 'المحور التفاضلي', icon: '⚖️' },
      ]
    },
    {
      id: 7,
      name: 'نظام الكهرباء والإلكترونيات',
      icon: '🔋',
      subcategories: [
        { id: 71, name: 'البطارية والشحن', icon: '⚡' },
        { id: 72, name: 'أنظمة الإضاءة', icon: '💡' },
        { id: 73, name: 'أجهزة الاستشعار', icon: '📡' },
        { id: 74, name: 'أنظمة التحكم', icon: '🎮' },
        { id: 75, name: 'أنظمة الترفيه', icon: '🎵' },
      ]
    },
    {
      id: 8,
      name: 'نظام التبريد والتدفئة',
      icon: '🌡️',
      subcategories: [
        { id: 81, name: 'المبرد والمروحة', icon: '💨' },
        { id: 82, name: 'مضخة المياه', icon: '💧' },
        { id: 83, name: 'الثرموستات', icon: '🌡️' },
        { id: 84, name: 'نظام التدفئة', icon: '🔥' },
        { id: 85, name: 'تكييف الهواء', icon: '❄️' },
      ]
    },
  ];

  // الفئات المميزة (البراندات)
  const featuredBrands = [
    { id: 101, name: 'Toyota', logo: '🎯', color: 'from-red-500 to-red-700' },
    { id: 102, name: 'Nissan', logo: '🔷', color: 'from-green-500 to-green-700' },
    { id: 103, name: 'Honda', logo: '🔴', color: 'from-gray-700 to-gray-900' },
    { id: 104, name: 'Hyundai', logo: '🔶', color: 'from-green-400 to-green-600' },
    { id: 105, name: 'Kia', logo: '⚫', color: 'from-gray-800 to-black' },
    { id: 106, name: 'Mercedes', logo: '⭐', color: 'from-gray-300 to-gray-500' },
    { id: 107, name: 'BMW', logo: '🌀', color: 'from-green-300 to-green-500' },
    { id: 108, name: 'Audi', logo: '🔶', color: 'from-red-700 to-black' },
  ];

  const toggleCategory = (categoryId) => {
    if (expandedCategories.includes(categoryId)) {
      setExpandedCategories(expandedCategories.filter(id => id !== categoryId));
    } else {
      setExpandedCategories([...expandedCategories, categoryId]);
    }
  };

  const handleCategorySelect = (category) => {
    setSelectedCategory(category.id);
    if (onSelectCategory) {
      onSelectCategory(category);
    }
  };

  return (
    <div className="w-full">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* القائمة الجانبية */}
        <div className="lg:col-span-3">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            {/* رأس القائمة */}
            <div className="bg-gradient-to-r from-green-600 to-green-700 p-6">
              <h2 className="text-2xl font-bold text-white mb-2">جميع الفئات</h2>
              <p className="text-green-100">اختر الفئة الفرعية لاستعراض القطع المتوفرة</p>
            </div>

            {/* قائمة الفئات */}
            <div className="divide-y divide-gray-100">
              {categories.map((category) => (
                <div key={category.id} className="group">
                  {/* الفئة الرئيسية */}
                  <div 
                    className={`flex items-center justify-between p-5 cursor-pointer transition-all duration-300 ${
                      expandedCategories.includes(category.id) 
                        ? 'bg-gradient-to-r from-green-50 to-green-50' 
                        : 'hover:bg-gray-50'
                    }`}
                    onClick={() => toggleCategory(category.id)}
                  >
                    <div className="flex items-center">
                      <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-2xl ml-4 ${
                        expandedCategories.includes(category.id)
                          ? 'bg-gradient-to-r from-green-500 to-green-600 text-white'
                          : 'bg-gradient-to-r from-gray-100 to-gray-200 text-gray-700'
                      }`}>
                        {category.icon}
                      </div>
                      <div>
                        <h3 className="text-2xl font-semibold text-gray-900">{category.name}</h3>
                        <p className="text-2xl text-gray-600">{category.subcategories.length} فئة فرعية</p>
                      </div>
                    </div>
                    <div className="flex items-center">
                      <span className={`text-2xl font-medium px-3 py-1 rounded-full ml-4 ${
                        expandedCategories.includes(category.id)
                          ? 'bg-white text-green-600'
                          : 'bg-gray-100 text-gray-700'
                      }`}>
                        {category.subcategories.length}
                      </span>
                      <svg 
                        className={`w-6 h-6 text-gray-600 transform transition-transform duration-300 ${
                          expandedCategories.includes(category.id) ? 'rotate-180' : ''
                        }`}
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                      </svg>
                    </div>
                  </div>

                  {/* الفئات الفرعية */}
                  {expandedCategories.includes(category.id) && (
                    <div className="bg-gradient-to-r from-gray-50 to-white p-4 border-t border-gray-100">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        {category.subcategories.map((subcategory) => (
                          <button
                            key={subcategory.id}
                            onClick={() => handleCategorySelect(subcategory)}
                            className={`flex items-center p-4 rounded-xl text-right transition-all duration-300 ${
                              selectedCategory === subcategory.id
                                ? 'bg-gradient-to-r from-green-500 to-green-600 text-white shadow-lg transform scale-[1.02]'
                                : 'bg-white hover:bg-gray-50 text-gray-800 hover:shadow-md border border-gray-100'
                            }`}
                          >
                            <div className={`w-10 h-10 rounded-lg flex items-center justify-center text-2xl ml-4 ${
                              selectedCategory === subcategory.id
                                ? 'bg-white/20 text-white'
                                : 'bg-gradient-to-r from-gray-100 to-gray-200 text-gray-700'
                            }`}>
                              {subcategory.icon}
                            </div>
                            <div className="flex-1">
                              <div className="font-semibold">{subcategory.name}</div>
                              <div className={`text-2xl mt-1 ${
                                selectedCategory === subcategory.id ? 'text-green-100' : 'text-gray-500'
                              }`}>
                                استعراض القطع
                              </div>
                            </div>
                            <svg 
                              className={`w-5 h-5 ${selectedCategory === subcategory.id ? 'text-white' : 'text-gray-400'}`}
                              fill="none" 
                              stroke="currentColor" 
                              viewBox="0 0 24 24"
                            >
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                            </svg>
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* قسم الفئات المميزة */}
            {/* <div className="border-t border-gray-100 p-6">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">الفئات المميزة</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="bg-gradient-to-r from-green-50 to-green-50 rounded-xl p-4 border border-green-100 text-center cursor-pointer hover:shadow-lg transition-all duration-300">
                  <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-green-600 rounded-full flex items-center justify-center text-white text-2xl mx-auto mb-3">
                    🔥
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-1">الأكثر مبيعاً</h4>
                  <p className="text-2xl text-gray-600">القطع الأكثر طلباً</p>
                </div>
                <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-4 border border-green-100 text-center cursor-pointer hover:shadow-lg transition-all duration-300">
                  <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center text-white text-2xl mx-auto mb-3">
                    ⭐
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-1">الأعلى تقييماً</h4>
                  <p className="text-2xl text-gray-600">قطع مميزة بتقييمات عالية</p>
                </div>
                <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl p-4 border border-purple-100 text-center cursor-pointer hover:shadow-lg transition-all duration-300">
                  <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-pink-600 rounded-full flex items-center justify-center text-white text-2xl mx-auto mb-3">
                    💰
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-1">العروض الخاصة</h4>
                  <p className="text-2xl text-gray-600">خصومات تصل إلى 50%</p>
                </div>
                <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-xl p-4 border border-orange-100 text-center cursor-pointer hover:shadow-lg transition-all duration-300">
                  <div className="w-16 h-16 bg-gradient-to-r from-orange-500 to-red-600 rounded-full flex items-center justify-center text-white text-2xl mx-auto mb-3">
                    🚀
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-1">القطع الجديدة</h4>
                  <p className="text-2xl text-gray-600">أحدث القطع المضافة</p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryTree;